import { type ReactNode } from 'react'
import { ChromeThemeLayer, useChromeThemeColor } from '@/features/shell/theming'
import { useCssVariable } from '@/features/shell/theming/use-css-variable'
import { useIsSpacious } from '@/hooks/viewport-hooks'

interface BaseChromeThemeContainerProps {
  children?: ReactNode
}

/**
 * Manages the base chrome theme layer.
 * "Chrome" in this context refers to the browser UI surrounding the web
 * content.
 */
export function BaseChromeThemeContainer({
  children,
}: BaseChromeThemeContainerProps) {
  const isSpacious = useIsSpacious()
  useChromeThemeColor(
    // On larger screens when the global navbar is left-aligned,
    // we'll use the default border color as the chrome color.
    // Otherwise, we use the default background color.
    useCssVariable(isSpacious ? '--border-color-default' : '--surface-primary'),
    ChromeThemeLayer.Root,
  )

  return children
}
